import { render, staticRenderFns } from "./FlagBanner.vue?vue&type=template&id=71f9dd24&scoped=true"
import script from "./FlagBanner.vue?vue&type=script&lang=js"
export * from "./FlagBanner.vue?vue&type=script&lang=js"
import style0 from "./FlagBanner.vue?vue&type=style&index=0&id=71f9dd24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f9dd24",
  null
  
)

export default component.exports